import { cn } from "@/utils/cn";
import React from "react";
import InputShell from "./InputShell";

type Props = {
  label?: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  transformInput?: (value: string) => string;
  className?: string;
  textAreaClassName?: string;
  required?: boolean;
  error?: string[] | string;
};

const TextArea = ({
  label,
  value,
  onChange,
  transformInput = (value) => value.toUpperCase(),
  placeholder = "Enter Message",
  className,
  textAreaClassName,
  required = false,
  error
}: Props) => {
  return (
    <div className={cn("my-2", className)}>
      <InputShell label={label} required={required ? true : undefined} error={error}>
        <textarea
          name="textArea"
          value={value}
          onChange={(e) =>
            onChange?.(transformInput ? transformInput(e.target.value) : e.target.value)
          }
          placeholder={placeholder}
          className={cn(
            "w-full rounded-[0.25rem] border border-outline p-3 text-sm leading-4 placeholder:text-[#9BA5B7] focus:outline-none disabled:bg-slate-100 disabled:text-slate-500",
            textAreaClassName
          )}
        />
      </InputShell>
    </div>
  );
};

export default TextArea;
